import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingData: false,
  isLoading: false,
  doctors: [],
  message: null,
  pageSize: "5",
  page: "1",
  totalPages: 1,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const doctorsSlice = createSlice({
  name: "doctors",
  initialState,
  reducers: {
    onLoadingDoctors: (state) => {
      state.isLoadingData = true;
      state.message = null;
    },
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onLoaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    onLoadDoctors: (state, { payload }) => {
      const { page, totalPages, doctors } = payload;
      state.isLoadingData = false;
      state.message = null;
      state.doctors = doctors;
      state.page = page;
      state.totalPages = totalPages;
    },
    onFailedDoctors: (state, { payload }) => {
      state.isLoadingData = false;
      state.message = {
        type: "errorDoctors",
        text: payload,
      };
      resetState(state, ["doctors"]);
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    changePageSize: (state, { payload }) => {
      state.pageSize = payload;
    },
    changePage: (state, { payload }) => {
      state.page = payload;
    },
    onUpdateDoctor: (state, { payload }) => {
      const index = state.doctors.findIndex(
        (doctor) => doctor.id === payload.id
      );
      if (index !== -1) {
        state.doctors[index] = {
          ...payload,
        };
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadingDoctors,
  onLoading,
  onLoaded,
  onLoadDoctors,
  onFailedDoctors,
  onErrorMessage,
  onSuccessMessage,
  changePageSize,
  changePage,
  onUpdateDoctor,
} = doctorsSlice.actions;
